import RadioButton from 'coreOld/components/RadioButton';

interface IProps {
  name?: string;
  value?: string;
  groupLabel?: string;
  onChange?;
  options?;
}

const RadioGroupView = ({ value, options, onChange }: IProps) => {
  return (
    <div>
      {options.map(({ option, label }) => (
        <RadioButton
          key={option}
          {...{
            option,
            label,
            name: option,
            value,
            onChange: (opt) => onChange(opt),
          }}
        />
      ))}
    </div>
  );
};

export default RadioGroupView;
